import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, map, tap } from 'rxjs';
import { Login } from 'src/app/model/login.model';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-active-account',
  templateUrl: './active-account.component.html',
  styleUrls: ['./active-account.component.css']
})
export class ActiveAccountComponent implements OnInit {

  
  titleCard: string = 'Pour se connecter';
  userForm!: FormGroup;
  constructor(private router : Router, private authservice: AuthService, private formBuilder: FormBuilder) { }

  token!: string;
  ngOnInit()
  {
      this.initForm();
     
  }

  onSubmitForm()  : void{
   
    const formValue = this.userForm.value;
    const newUser2 = formValue['username'];

    this.authservice
        .checkUser(newUser2)
        .pipe(
          map((data)=>{
            if(data.countExist){
              this.router.navigateByUrl('auth/login')
            }else{
              
              if(data.object !== null){
                this.router.navigate(['auth/register'],{queryParams:{
                  email:data.object.email,
                  firstname:data.object.firstname,
                  lastname:data.object.lastname,
                  username:data.object.username
                }})
              }else{
                this.router.navigateByUrl('auth/register')
              }
             
            }
          }),
        catchError((err) => {
            //// //console.log(err)
            return err;
        })
        )
        .subscribe()

    

      }
      initForm() {
        this.userForm = this.formBuilder.group({
            username: [''],
        });
      }


}
